const email = {
  author: "author@uncookd.com",
  feedback: "feedback@uncookd.com",
  dnr: "donotreply@uncookd.com",
};

module.exports = email;
